import script from "./Help.vue?vue&type=script&setup=true&lang=js"
export * from "./Help.vue?vue&type=script&setup=true&lang=js"

import "./Help.vue?vue&type=style&index=0&id=f5efc662&scoped=true&lang=css"

import exportComponent from "/home/runner/work/INPEOPLE-HUB/INPEOPLE-HUB/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5efc662"]])

export default __exports__